/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_6f4c3e5b"]'><div :class='["dialog-show-slot-demo"]'><cube-button @_click="onClickDialog">Dialog - title & content slot</cube-button><cube-dialog ref="__mpx_ref_dialogWithSlot__" confirm-btn="我知道了"><div slot="title" :class='["dialog-show-slot-title"]'><mpx-image mode="aspectFit" src="https://dpubstatic.udache.com/static/dpubimg/911dcd99-4fe5-43b3-9178-6a25d9847be8.png" :class='["show-slot-img"]'></mpx-image></div><div slot="content" :class='["dialog-show-slot-content"]'>我是slot-content</div></cube-dialog></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_6f4c3e5b"}'>
.dialog-show-slot-content
  text-align center
.show-slot-img
  width 100%
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_6f4c3e5b"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_6f4c3e5b"}
  /** script content **/
  require("./dialog-show-slot.mpx.js?isComponent&outputPath=components%2Fdialog-show-slot6f4c3e5b%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./dialog-show-slot.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fdialog-show-slot6f4c3e5b%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_6f4c3e5b"],
    ctorType: "component",
    outputPath: "components/dialog-show-slot6f4c3e5b/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex")),'cube-dialog':getComponent(require("../../../packages/mpx-cube-ui/src/components/dialog/index.mpx?isComponent&outputPath=components%2Findex8b435562%2Findex")),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image?isComponent"), {__mpxBuiltIn: true})},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>